import * as actionTypes from "./actionTypes";

export const toggleMenuIcon = () => {
  return {
    type: actionTypes.TOGGLE_MENU_ICON,
  };
};
